const ExcludePatterns = [
  '^/(for-sale|buyer)/(product|service)/',
  '^/(offering|wanted)/\\d',
  '^/chats/0$',
];

const ExcludeRegex = RegExp(`(${ExcludePatterns.join(')|(')})`);

export default function isExcludedUrl(url) {
  return ExcludeRegex.test(url);
}
